import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ContextService {
	procoreIsSandbox;
	// this.contextService.procoreIsSandbox = true or false

	procoreAuthCode;
	// this.contextService.procoreAuthCode = "12345"

	procoreUserInfo: any;
	// this.contextService.procoreUserInfo.email = "brad.hickey@shakeit.ai"
	// this.contextService.procoreUserInfo.procoreUserId = "12345"

	procoreContextObject: any;
	// this.contextService.procoreContextObject.context.id = "12345"
	// this.contextService.procoreContextObject.context.company_id = "12345"
	// this.contextService.procoreContextObject.context.project_id = "12345"
	// this.contextService.procoreContextObject.context.view = "purchase_order_contracts"

	client: any;
	// this.client.clientId
	// this.client.clientName
	// this.client.stripeCustomerId
	// this.client.isActive

	clientDetailProcore: any;
	// this.contextService.clientDetailProcore.clientId = "12345"
	// this.contextService.clientDetailProcore.applicationEnabled = true or false
	// this.contextService.clientDetailProcore.companyId = "12345"
	// this.contextService.clientDetailProcore.procoreDomain
	// this.contextService.clientDetailProcore.licenseExpirationDate
	// this.contextService.clientDetailProcore.renewalType = "auto" or "manual"
	// this.contextService.clientDetailProcore.isTrial = true or false
	// this.contextService.clientDetailProcore.setExecutedAfterCompleted = true or false
	// this.contextService.clientDetailProcore.purchaseOrderStatusAfterRequested
	// this.contextService.clientDetailProcore.purchaseOrderStatusAfterCompleted
	// this.contextService.clientDetailProcore.subContractStatusAfterRequested
	// this.contextService.clientDetailProcore.subContractStatusAfterCompleted
	// this.contextService.clientDetailProcore.primeContractStatusAfterRequested
	// this.contextService.clientDetailProcore.primeContractStatusAfterCompleted
	// this.contextService.clientDetailProcore.enableMultipleAttachments = true or false
	// this.contextService.clientDetailProcore.allowDeclineRequest = true or false
	// this.contextService.clientDetailProcore.declineRequestDefault = true or false
	// this.contextService.clientDetailProcore.useExportedFile = true or false
	// this.contextService.clientDetailProcore.allowSignerReassignment = true or false
	// this.contextService.clientDetailProcore.requestorEmailType
	// this.contextService.clientDetailProcore.customRequestorEmail
	// this.contextService.clientDetailProcore.allowExpirationDate = true or false
	// this.contextService.clientDetailProcore.adobeAccountType
	// this.contextService.clientDetailProcore.adobeApplicationId
	// this.contextService.clientDetailProcore.adobeApplicationClientSecret
	// this.contextService.clientDetailProcore.AdobeTestMode = true or false

	stripeCustomerId: string;
	// this.contextService.customerId = "12345"

	signatureCount: any;
	// this.contextService.signatureCount.signatures.total
	// this.contextService.signatureCount.signatures.used

	constructor() { }
}
